import { useParams } from 'react-router-dom';

import { useGetRoomsByIdQuery } from '@client/api';

import { RoomInformationCard } from '../components/room-information-card.component';

export const RoomView = () => {
  const { spaceId } = useParams<{ spaceId: string }>();

  const { data: space, isFetching } = useGetRoomsByIdQuery(
    {
      id: spaceId ?? '',
    },
    { skip: !spaceId },
  );

  return (
    <div className="relative md:flex">
      <div className="w-full mb-2 space-y-2">
        <RoomInformationCard space={space} isFetching={isFetching} />
      </div>
    </div>
  );
};
